module.exports = __webpack_public_path__ + "img/MobileImage4_en.a32c1bca.png";